import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone, forEach } from "lodash";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetCivilBudgetScheduleState, getCivilBudgetSchedule as onGetCivilBudgetSchedules, addNewCivilBudgetSchedule as onAddNewCivilBudgetSchedule, updateCivilBudgetSchedule as onUpdateCivilBudgetSchedule, deleteCivilBudgetSchedule as onDeleteCivilBudgetSchedule, getCivilBudgetScheduleLoading } from "../../../store/civilBudgetSchedule/action";
import { resetCivilBudgetState, getCivilBudget as onGetCivilBudgets } from "../../../store/civilBudget/action";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExporMultiDoc from "../../../Components/Common/ExportMultiDoc";

const CivilBudget = () => {
  const filerIdRef = useRef({
    branchId: 1
  })
  const [modal, setModal] = useState(false);
  const [modalScheduleDate, setModalScheduleDate] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, civilBudgets, loading, error, civilBudgetSchedules, civilBudgetScheduleLoading, isCivilBudgetScheduleCreated, isCivilBudgetScheduleSuccess } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    civilBudgets: state.CivilBudget.civilBudgets,
    loading: state.CivilBudget.loading,
    error: state.CivilBudget.error,
    civilBudgetSchedules: state.CivilBudgetSchedule.civilBudgetSchedules,
    civilBudgetScheduleLoading: state.CivilBudgetSchedule.loading,
    isCivilBudgetScheduleCreated: state.CivilBudgetSchedule.isCivilBudgetScheduleCreated,
    isCivilBudgetScheduleSuccess: state.CivilBudgetSchedule.isCivilBudgetScheduleSuccess
  }));

  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [civilBudgetSelectList, setCivilBudgetSelectList] = useState([]);
  const [civilBudget, setCivilBudget] = useState([]);
  const [componentScheduleAddedId, setComponentScheduleAddedId] = useState(0);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [civilBudgetSchedule, setCivilBudgetSchedule] = useState([]);
  const [scheduleDateInputVal, setScheduleDateInputVal] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [totalBudget, setTotalBudget] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalSchedule, setDeleteModalSchedule] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [dataPrintDoc, setDataPrintDoc] = useState([])

  useEffect(() => {
      if (companySelected && branchSelected) {
        dispatch(resetCivilBudgetState());
        dispatch(onGetCivilBudgets({ companyId: companySelected.value, branchId: branchSelected.value }));
      }
    }, [companySelected, branchSelected]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      setIsEdit(false);
      setCivilBudgetList(civilBudgets);
    }
  }, [civilBudgets, componentScheduleAddedId]);

  useEffect(() => {
    if (isCivilBudgetScheduleCreated) {
      dispatch(resetCivilBudgetScheduleState());
      dispatch(resetCivilBudgetState());
      dispatch(onGetCivilBudgets({ companyId: companySelected.value, branchId: branchSelected.value }));
    }
  }, [dispatch, isCivilBudgetScheduleCreated]);

  useEffect(() => {
    var data = [];
    var opt = [];
    civilBudgets.forEach((item, key) => {
      const name = item.cvl_branch ? item.cvl_branch.name + ' - ' + item.name : item.name;
      const id = item.id;
      var obj = { label: name, value: id, data: item };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (civilBudgets.length > 0) {
      setCivilBudgetSelectList(data);
    }
  }, [civilBudgets]);

  const toggleScheduleDate = useCallback(() => {
    if (modalScheduleDate) {
      setModalScheduleDate(false);
    } else {
      setModalScheduleDate(true);
    }
  }, [modalScheduleDate]);

  const addScheduleDateToAllItems = (scheduleDate) => {
    let startat = "";
    let endat = "";
    let datearr = scheduleDate.split(" to ");
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    validation.setFieldValue("startat", startat);
    validation.setFieldValue("endat", endat);

    let diff = moment.duration(moment(endat).diff(moment(startat)));
    let week = Math.floor(diff.asWeeks());
    if (diff.days() % 7 > 0)
      week = week + 1;

    let arrSchedule = [];
    for (var m = 0; m < week; m++) {
      arrSchedule.push({ date: "M-" + (m + 1), total: 0 });
    }

    validation.setFieldValue("schedule", arrSchedule);

    let arrCat = [];
    let ttlBudget = 0;
    let ttlWeight = 0;
    for (const detail of validation.values.schedule_detail) {
      let arrData = [];
      for (const data of detail.data) {
        let obj = {
          civilBudgetId: data.civilBudgetId,
          civilBudgetDetailId: data.civilBudgetDetailId,
          clientId: data.clientId,
          companyId: data.companyId,
          civilAccountId: data.civilAccountId,
          code: data.code,
          name: data.name,
          category_name: data.category_name,
          type: data.type,
          quantity: data.quantity,
          amount: data.amount,
          total: data.total,
          weight: data.weight,
        }
        ttlBudget += data.total ? parseFloat(data.total) : 0;
        ttlWeight += data.weight ? parseFloat(data.weight) : 0;
        let arrDate = [];

        for (var o = 0; o < week; o++) {
          arrDate.push({ date: "M-" + (o + 1), percentage: 0 });
        }
        obj.schedule = arrDate;
        arrData.push(obj);
      }
      arrCat.push({
        title: detail.title,
        startat: startat,
        endat: endat,
        data: arrData
      });
    }
    setTotalBudget(ttlBudget);
    setTotalWeight(ttlWeight);
    validation.setFieldValue("schedule_detail", arrCat.map((data) => ({ id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`, ...data })));
  };

  const handleCivilBudgetClick = (object) => {
    setTotalBudget(0);
    setTotalWeight(0);
    setCivilBudget(object);
    let arrCat = [];
    let ttlBudget = 0;
    let ttlAllBudget = parseFloat(0);
    let ttlWeight = 0;
    let startat = object.startat ? handleValidDate(object.startat, "YYYY-MM-DD") : "";
    let endat = object.endat ? handleValidDate(object.endat, "YYYY-MM-DD") : "";
    let unit = object.unit ? parseFloat(object.unit) : 1;
    validation.setFieldValue("unit", unit);
    validation.setFieldValue("startat", startat);
    validation.setFieldValue("endat", endat);
    for (const cvl of civilBudgetList) {
      for (const cvld of cvl.cvl_detail) {
        if (object.branchId === cvl.branchId) {
          if (cvl.type === "BANGUNAN") {
            ttlAllBudget += cvld.quantity < 1 ? (parseFloat(cvld.amount) * parseFloat(unit)) : parseFloat(cvld.amount);
          }
          else {
            ttlAllBudget += parseFloat(cvld.amount);
          }
        }
      }
    }
    validation.setFieldValue("total", Math.round(ttlAllBudget));

    if (object.cvl_schedule) {
      for (const d of (object.cvl_schedule.detail || [])) {
        let arr = [];
        for (const data of d.data) {
          ttlBudget += data.amount && data.quantity < 1 ? parseFloat(data.amount) * parseFloat(unit) : parseFloat(data.amount);
          ttlWeight += data.weight ? parseFloat(data.weight) : 0;
          let civilAccountId;
          if (!data.civilAccountId) {
            let budgetData = civilBudgetList.find(x => x.type === data.type).cvl_detail;
            civilAccountId = budgetData.find(x => x.cvld_account && x.cvld_account.name === data.name) && budgetData.find(x => x.cvld_account && x.cvld_account.name === data.name).civilAccountId;
          }
          else {
            civilAccountId = data.civilAccountId;
          }

          arr.push({
            civilBudgetId: data.civilBudgetId,
            clientId: data.clientId,
            companyId: data.companyId,
            civilAccountId: civilAccountId,
            code: data.code,
            name: data.name,
            category_name: d.title,
            type: data.type,
            quantity: data.quantity,
            amount: data.amount,
            total: data.amount && data.quantity < 1 ? parseFloat(data.amount) * parseFloat(unit) : parseFloat(data.amount),
            weight: data.weight,
            schedule: data.schedule ? data.schedule : [],
          });

          //civilBudgetList.find
        }
        //end for
        arrCat.push({
          title: d.title,
          data: arr
        });
      }

      let diff = moment.duration(moment(endat).diff(moment(startat)));
      let week = Math.floor(diff.asWeeks());
      if (diff.days() % 7 > 0)
        week = week + 1;

      let arrSchedule = [];
      for (var m = 0; m < week; m++) {
        let total = 0;
        for (const detail of arrCat) {
          for (const data of detail.data) {
            for (const ische of data.schedule) {
              if (ische.date === "M-" + (m + 1)) {
                total += ische.percentage ? parseFloat(ische.percentage) : 0;
              }
            }
          }
        }
        arrSchedule.push({ date: "M-" + (m + 1), total: total.toFixed(2) });
      }
      validation.setFieldValue("schedule", arrSchedule);
      setTotalBudget(ttlBudget);
      setTotalWeight(ttlWeight);
      validation.setFieldValue("schedule_detail", arrCat.map((data) => ({ id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`, ...data })));
    }
    else {

      for (const data of object.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
        ttlBudget += data.amount && data.quantity < 1 ? parseFloat(data.amount) * parseFloat(unit) : parseFloat(data.amount);
        ttlWeight += data.weight ? parseFloat(data.weight) : 0;
        let category = data.cvld_account && data.cvld_account.cvl_account_category ? data.cvld_account.cvl_account_category.name : "";
        let findCat = arrCat.find(x => x.title === category);
        if (findCat) {
          findCat.data.push({
            civilBudgetId: object.id,
            clientId: data.clientId,
            companyId: data.companyId,
            civilAccountId: data.civilAccountId,
            code: data.cvld_account ? data.cvld_account.code : "",
            name: data.cvld_account ? data.cvld_account.name : "",
            category_name: category,
            type: data.type,
            quantity: data.quantity,
            amount: data.amount,
            total: data.amount && data.quantity < 1 ? parseFloat(data.amount) * parseFloat(unit) : parseFloat(data.amount),
            weight: data.weight,
          });
        }
        else {
          arrCat.push({
            title: category,
            data: [{
              civilBudgetId: object.id,
              civilBudgetDetailId: data.id,
              clientId: data.clientId,
              companyId: data.companyId,
              civilAccountId: data.cvld_account ? data.cvld_account.id : null,
              code: data.cvld_account ? data.cvld_account.code : "",
              name: data.cvld_account ? data.cvld_account.name : "",
              category_name: category,
              type: data.type,
              quantity: data.quantity,
              amount: data.amount,
              total: data.amount && data.quantity < 1 ? parseFloat(data.amount) * parseFloat(unit) : parseFloat(data.amount),
              weight: data.weight,
            }]
          });
        }
      }

      setTotalBudget(ttlBudget);
      setTotalWeight(ttlWeight);
      validation.setFieldValue("schedule_detail", arrCat);
    }
  }

  const handleSchedulePercentage = () => {
    let arr = [];
    for (const sch of validation.values.schedule) {
      let total = 0;
      for (const detail of validation.values.schedule_detail) {
        for (const data of detail.data) {
          for (const ische of data.schedule) {
            if (ische.date === sch.date) {
              total += ische.percentage ? parseFloat(ische.percentage) : 0;
            }
          }
        }
      }
      arr.push({ date: sch.date, total: total.toFixed(2) });
    }

    validation.setFieldValue("schedule", arr);
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      civilBudgetId: (civilBudgetSchedule && civilBudgetSchedule.civilBudgetId) ?? "",
      branchId: (civilBudgetSchedule && civilBudgetSchedule.branchId) ?? "",
      company: (civilBudgetSchedule && civilBudgetSchedule.company) || companySelected,
      client: (civilBudgetSchedule && civilBudgetSchedule.client) || clientSelected,
      startat: (civilBudgetSchedule && civilBudgetSchedule.startat) ?? "",
      endat: (civilBudgetSchedule && civilBudgetSchedule.endat) ?? "",
      name: (civilBudgetSchedule && civilBudgetSchedule.name) ?? "",
      unit: (civilBudgetSchedule && civilBudgetSchedule.unit) || 1,
      total: (civilBudgetSchedule && civilBudgetSchedule.total) || 0,
      schedule: (civilBudgetSchedule && civilBudgetSchedule.schedule) || [],
      schedule_detail: (civilBudgetSchedule && civilBudgetSchedule.schedule_detail) || [],
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      dispatch(getCivilBudgetScheduleLoading());
      const newCivilBudgetSchedule = {
        civilBudgetId: values.civilBudgetId,
        branchId: values.civilBudgetId,
        startat: values.startat,
        endat: values.endat,
        unit: values.unit,
        companyId: values.company.value,
        clientId: values.client.value,
        schedule: values.schedule,
        schedule_detail: values.schedule_detail,
      };
      dispatch(onAddNewCivilBudgetSchedule(newCivilBudgetSchedule));
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCivilBudgetSchedule(element.value));
    });
    checkall.checked = false;
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const labels = [
    { key: "name", label: "URAIAN PEKERJAAN" },
    { key: "total", label: "JUMLAH" }];

  useEffect(() => {
    const updatedData = validation.values.schedule_detail
      .map(title => {
        const filteredItems = title.data;
        const newTitleSelected = filteredItems.length > 0;
        return {
          ...title,
          isSelected: newTitleSelected,
          data: filteredItems,
        };
      })
      .filter(title => title.data.length > 0);

    const dataFinalDoc = updatedData.map(section => ({
      title: section.title,
      data: section.data.map(item => {
        const transformed = {};
        labels.forEach(({ key, label }) => {

          if (key in item) {
            if (key === "total") {
              transformed[label] = currencyFormat(item[key]);
            } else if (key === "weight") {
              transformed[label] = `${item[key]}%`;
            } else {
              transformed[label] = item[key];
            }

          }
        });

        if ("weight" in item) {
          transformed["UNIT"] = validation.values.unit;
          transformed["BOBOT"] = `${item.weight}%`
        }

        if ("schedule" in item) {
          for (const [index, el] of item.schedule.entries()) {
            transformed[el.date] = el.percentage
            // transformed[`ACTUAL_${el.date}`] = el.progress > 0 ? parseFloat((item.weight / unit) * el.progress).toFixed(3) : ""
            // transformed[`KEBUTUHAN DANA_${el.date}`] = currencyFormat(parseFloat(item.total_unit/item.percentage).toFixed(0))
          }
        }
        return transformed;
      })
    }));

    setDataPrintDoc(dataFinalDoc)
  }, [validation.values.schedule_detail])

  document.title = "Jadwal Anggaran | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Teknik" pageTitle="Jadwal Anggaran" />
        <Row>
          <Col sm={12}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <div className="mb-2 flex-grow-1">
                  <h5 className="text-uppercase">JADWAL KERJA RAB &nbsp; {loading && (
                    <>
                      <Spinner color="primary" type="grow" size={"sm"}>
                        Loading...
                      </Spinner>
                      &nbsp;
                      <Spinner color="success" type="grow" size={"sm"}>
                        Loading...
                      </Spinner>
                      &nbsp;
                    </>
                  )}</h5>
                  <h4 className="mb-1 text-uppercase text-success">{validation.values.name !== "" && validation.values.name}</h4>
                  <p className="fs-14">{validation.values.startat !== "" && "Tanggal : " + handleValidDate(validation.values.startat) + " - " + handleValidDate(validation.values.endat)}</p>
                  <div className="hstack gap-1">
                    JUMLAH UNIT
                    <Input onBlur={validation.handleBlur} value={validation.values.unit} onFocus={e => e.target.select()} name="unit" id="unit-field" className="form-control justify-content-end ms-2" style={{ width: "100px" }} placeholder="1" type="number" onChange={(e) => {
                      let value = parseFloat(e.target.value);
                      let ttlAllBudget = 0;
                      if (!isNaN(value)) {
                        validation.setFieldValue("unit", value);
                        for (const cvl of civilBudgetList) {
                          for (const cvld of cvl.cvl_detail) {
                            if (civilBudget.branchId === cvl.branchId) {
                              if (cvl.type === "BANGUNAN") {
                                ttlAllBudget += cvld.quantity < 1 ? (parseFloat(cvld.amount) * parseFloat(value)) : parseFloat(cvld.amount);
                              }
                              else {
                                ttlAllBudget += parseFloat(cvld.amount);
                              }
                            }
                          }
                        }
                        validation.setFieldValue("total", ttlAllBudget);
                      }
                    }} />
                    {validation.values.schedule_detail.length > 0 &&
                      <div className="px-3 d-flex align-items-center justify-content-end">
                        <div className="flex-shrink-0">
                          <ExporMultiDoc data={dataPrintDoc} />
                        </div>
                      </div>}
                  </div>
                </div>
                <div className="flex-shrink-0">
                  <div className="mb-3" style={{ position: "relative", width: "520px", zIndex: 1000 }}>
                    <Select
                      name="branch"
                      className="text-uppercase w-100"
                      placeholder=" Pilih Aggaran Proyek "
                      style={{ position: "absolute" }}
                      onChange={(e) => {
                        validation.resetForm();
                        handleCivilBudgetClick(e.data);
                        validation.setFieldValue("name", e.label);
                        validation.setFieldValue("civilBudgetId", e.value);
                        validation.setFieldValue("branchId", e.data.branchId);
                        validation.setFieldValue("clientId", e.data.clientId);
                        validation.setFieldValue("companyId", e.data.companyId);
                      }}
                      options={civilBudgetSelectList}></Select>
                  </div>
                  <div className="hstack gap-2 justify-content-end">
                    <button
                      type="button"
                      className="btn w-50 col-lg-6 btn-info text-center"
                      id="create-btn"
                      onClick={() => { toggleScheduleDate() }}>ATUR JADWAL</button>
                    <button
                      type="button"
                      className="btn w-50 btn-success add-btn text-center"
                      id="create-btn"
                      onClick={() => { validation.handleSubmit() }}>SIMPAN &nbsp; {civilBudgetScheduleLoading && (
                        <Spinner size="sm" className="flex-shrink-0" role="status">Loading...</Spinner>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive table-card mb-3 d-none">

                  {validation.values.schedule_detail.length > 0 && (
                    <Table className="table-strip text-center table-nowrap align-middle mb-0 w-100">
                      <thead>
                        <tr className="table-active">
                          <th className="text-start overflow-hidden fs-15 w-75" style={{ verticalAlign: "middle" }}>REKAP ANGGARAN</th>
                          <th className="text-end overflow-hidden fs-14 hstack w-50"></th>
                        </tr>
                      </thead>
                      <tbody id="products-list">
                        {(civilBudgetList || []).map((element, index) => {
                          let total = 0;
                          let label = element.type === "BANGUNAN" || element.type === "UPAH" ? "(" + validation.values.unit + " Unit)" : "";
                          for (const data of element.cvl_detail) {
                            if (element.type === "BANGUNAN") {
                              total += data.quantity < 1 ? (parseFloat(data.amount) * parseFloat(validation.values.unit)) : parseFloat(data.amount);
                            }
                            else {
                              total += parseFloat(data.amount);
                            }
                          }
                          return (<tr key={index} className="product">
                            <td className="text-start overflow-hidden fs-14"><span className="fw-semibold text-uppercase">{element.name}</span> {label}</td>
                            <td className="text-end overflow-hidden fs-14 fw-semibold" style={{ width: "180px" }}>{currencyFormat(Math.round(total))}</td>
                          </tr>);
                        })}
                      </tbody>
                      <tbody id="products-list">
                        <tr className="product">
                          <td className="text-end overflow-hidden fs-14">TOTAL KEBUTUHAN ANGGARAN</td>
                          <td className="text-end overflow-hidden fs-18 text-success fw-semibold" style={{ width: "180px" }}>{currencyFormat(validation.values.total)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
                <div className="table-responsive table-card mb-1 mt-3">
                  {validation.values.schedule_detail.length > 0 ? (
                    <Table className="table-border text-center table-nowrap align-middle mb-0">
                      <thead>
                        <tr className="table-active">
                          <th scope="col" className="text-start fs-14">URAIAN PEKERJAAN</th>
                          <th scope="col" className="text-center fs-14 d-none" style={{ width: "50px" }}>HARGA</th>
                          <th scope="col" className="text-end fs-14 d-none">UNIT</th>
                          <th scope="col" className="text-end fs-14 d-none">TOTAL</th>
                          <th scope="col" className="text-center fs-14">BOBOT</th>
                          {(validation.values.schedule || []).map((element, index) => {
                            return (<th key={index} scope="col" className="text-center fs-14">{element.date}</th>);
                          })}
                        </tr>
                      </thead>
                      <tbody id="products-list">
                        {(validation.values.schedule_detail || []).map((element, index) => {
                          return (
                            <Fragment key={index}>
                              <tr className="product">
                                <td colSpan={4 + validation.values.schedule.length} className="text-start overflow-hidden fw-semibold fs-14" style={{ maxWidth: "100px", textOverflow: "ellipsis" }}>{element.title}</td>
                              </tr>
                              {(element.data || []).map((el, idx) => {
                                return (
                                  <tr className="product" key={idx}>
                                    <td className="text-start fs-14">{el.name}</td>
                                    <td className="text-center fw-semibold fs-14 d-none" style={{ width: "50px" }}>{currencyFormat(el.amount)}</td>
                                    <td className="text-center fw-semibold fs-14 d-none" style={{ width: "50px" }}>{el.quantity < 1 ? validation.values.unit : el.quantity}</td>
                                    <td className="text-end fw-semibold fs-14 d-none">{currencyFormat(el.total)}</td>
                                    <td className="text-center fw-semibold fs-14">{el.weight}%</td>
                                    {(el.schedule || []).map((ele, eleidx) => {
                                      return (
                                        <td key={eleidx} className="text-center">
                                          <Input name="weight" id="weight-field" className="form-control 14" placeholder="Enter Bobot" type="number" style={{ width: "90px" }}
                                            value={validation.values.schedule_detail[index].data[idx].schedule[eleidx].percentage}
                                            onFocus={e => e.target.select()}
                                            onChange={(e) => {
                                              let value = e.target.value;
                                              if (value === "") value = "0";
                                              validation.values.schedule_detail[index].data[idx].schedule[eleidx].percentage = value;
                                              validation.setFieldValue("schedule_detail", validation.values.schedule_detail);
                                              handleSchedulePercentage(ele.date, value);
                                            }} />
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                            </Fragment>
                          )
                        })}
                      </tbody>
                      <tfoot>
                        <tr className="table-active">
                          <th scope="col" className="text-end text-success fs-14">TOTAL</th>
                          <th scope="col" className="text-end text-success fs-15 d-none">{currencyFormat(totalBudget)}</th>
                          <th scope="col" className="text-center text-success fs-15">{currencyFormat(parseFloat(totalWeight).toFixed(2))}</th>
                          {(validation.values.schedule || []).map((element, index) => {
                            return (<th scope="col" className="text-center text-success fs-15" key={index}>{parseFloat(element.total).toFixed(2)}</th>);
                          })}
                        </tr>
                      </tfoot>
                    </Table>
                  )
                    : (
                      <Table className="table-border text-center table-nowrap align-middle mb-0">
                        <thead>
                          <tr className="table-active">
                            <th className="text-center overflow-hidden fs-14">URAIAN JADWAL KERJA</th>
                          </tr>
                        </thead>
                        <tbody id="products-list">
                          <tr className="product">
                            <td className="text-center overflow-hidden fs-14"><p className="pt-5 pb-5">Silahkan Pilih Proyek Terlebih Dahulu</p></td>
                          </tr>
                        </tbody>
                      </Table>
                    )}
                </div>
              </div>
            </Card>
          </Col>
          <Modal id="showModal1" isOpen={modalScheduleDate} centered size="md">
            <ModalHeader className="bg-light p-3" toggle={toggleScheduleDate}>
              Periode Target Anggaran
            </ModalHeader>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                addScheduleDateToAllItems(scheduleDateInputVal);
                toggleScheduleDate();
              }}>
              <ModalBody>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <Label htmlFor="name-field" className="form-label">
                        Tanggal
                      </Label>
                      <Flatpickr
                        className="form-control"
                        id="scheduleDate-input"
                        placeholder="Pilih Tanggal"
                        options={{
                          mode: "range",
                          dateFormat: "Y/m/d",
                        }}
                        onChange={(selectedDates, dateStr) => {
                          setScheduleDateInputVal(dateStr);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </ModalBody>
              <div className="modal-footer">
                <div className="hstack gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={toggleScheduleDate}>Tutup</button>
                  <button type="submit" className="btn btn-success">
                    <span className="d-flex align-items-center">
                      <span className="flex-grow-1 me-2">Simpan</span>
                    </span>
                  </button>
                </div>
              </div>
            </Form>
          </Modal>
        </Row>
        
      </Container>
    </div>
  );
};
export default CivilBudget;